import React, { useContext, useState } from 'react';
import { store } from './reducer';
import Skeleton from '@material-ui/lab/Skeleton';
import List from '@material-ui/core/List';
import PaymentItem from './PaymentItem';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import axios from 'api/axios';
import useToast from 'hooks/useToast';
import { useHistory } from 'react-router-dom';

const Drivers = () => {
  const {
    state: { bidders, order },
  } = useContext(store);
  const toast = useToast();
  const history = useHistory();

  const [loadingOrderStatusChange, setLoadingOrderStatusChange] = useState(
    false
  );

  async function changeStatus(orderId, status) {
    try {
      const { data } = await axios.post(`/api/v1/admin/orders/changeStatus`, {
        orderId,
        status,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  const handleClickChangeOrderStatus = async () => {
    try {
      setLoadingOrderStatusChange(true);
      const { messages } = await changeStatus(order._id, 'movingTowardsOrigin');
      history.replace(`/protected/admin/orders/${order._id}`);
      toast.success(messages[0]);
    } catch (error) {
      toast.error(error);
    } finally {
      setLoadingOrderStatusChange(false);
    }
  };

  if (order)
    return (
      <div>
        {order?.driversSelected?.length === order?.readyWaybills?.length && (
          <div className="text-center my-3">
            <Button
              onClick={handleClickChangeOrderStatus}
              color="secondary"
              variant="contained"
              disabled={loadingOrderStatusChange}
            >
              تغییر وضعیت سفارش به بارگیری
            </Button>
          </div>
        )}
        <Typography component="h2" variant="h2">
          {bidders?.length > 1 ? 'رانندگان:' : 'راننده:'}
        </Typography>
        <List>
          {bidders?.map((b) => (
            <PaymentItem
              key={b._id}
              payment={order?.totalCommission * 1}
              fullname={`${b?.driver?.user?.firstName || ''} ${
                b?.driver?.user?.lastName || ''
              }`}
              userId={b?.driver.user._id}
              driver={b?.driver}
              orderId={order?._id}
            />
          ))}
        </List>
      </div>
    );
  else return <Skeleton variant="text" height={112} />;
};

export default React.memo(Drivers);
